import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GenericLookupComponent } from './generic-lookup/generic-lookup.component';
import { HealthcareProviderLookupFormComponent } from './lookup-forms/healthcare-provider-lookup/healthcare-provider-lookup-form.component';
import { HealthcareProviderLookupSupervisoryRelationshipFormComponent } from './lookup-forms/healthcare-provider-supervisory-relationship-lookup/healthcare-provider-lookup-supervisory-relationship-form.component';
import { ClaimantLookupFormComponent } from './lookup-forms/claimant-lookup/claimant-lookup-form.component';
import { EmployerLookupFormComponent } from './lookup-forms/employer-lookup/employer-lookup-form.component';
import { DynamicFormsModule } from '../dynamic-forms/dynamic-forms.module';
import { MAT_DIALOG_DEFAULT_OPTIONS } from '@angular/material/dialog';
import { MaterialModule } from '../material/material.module';
import { FormsModule } from '@angular/forms';
import { DatatableModule } from '../datatable/datatable.module';
import { RouterModule } from '@angular/router';
import { InsurerLookupFormComponent } from './lookup-forms/insurer-lookup-form/insurer-lookup-form.component';
import { SystemUserLookupFormComponent } from './lookup-forms/system-user-lookup-form/system-user-lookup-form.component';
import { ThirdPartyAdministratorLookupFormComponent } from './lookup-forms/third-party-administrator-lookup-form/third-party-administrator-lookup-form.component';
import { UtilityModule } from '../utility/utility.module';
import { MedicalSupplierLookupFormComponent } from './lookup-forms/medical-supplier-lookup/medical-supplier-lookup.component';
import { AuthModule } from '../auth/auth.module';
import { InsurerExternalLookupFormComponent } from './lookup-forms/insurer-external-lookup-form/insurer-external-lookup-form.component';
import { ThirdPartyAdministratorExternalLookupFormComponent } from './lookup-forms/third-party-administrator-external-lookup-form/third-party-administrator-external-lookup-form.component';
import { ExternalUserLookupFormComponent } from './lookup-forms/external-user-lookup-form/external-user-lookup-form.component';

@NgModule({
  declarations: [
    GenericLookupComponent,
    HealthcareProviderLookupFormComponent,
    HealthcareProviderLookupSupervisoryRelationshipFormComponent,
    ClaimantLookupFormComponent,
    InsurerLookupFormComponent,
    SystemUserLookupFormComponent,
    InsurerExternalLookupFormComponent,
    EmployerLookupFormComponent,
    MedicalSupplierLookupFormComponent,
    ThirdPartyAdministratorLookupFormComponent,
    ThirdPartyAdministratorExternalLookupFormComponent,
    ExternalUserLookupFormComponent,
  ],
  imports: [
    CommonModule,
    UtilityModule,
    MaterialModule,
    FormsModule,
    DynamicFormsModule,
    DatatableModule,
    RouterModule,
    AuthModule,
  ],
  exports: [GenericLookupComponent],
  providers: [
    {
      provide: MAT_DIALOG_DEFAULT_OPTIONS,
      useValue: { width: '80vw', data: null, hasBackdrop: true, disableClose: true, restoreFocus: true },
    },
  ],
})
export class LookupModule {}
